export default __webpack_public_path__ + "static/media/profit-projections-min.64d133bc.png";